import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

import { useGetActionsQuery } from 'api';
import { ActivityWidget } from 'components';
import { useNotify } from 'hooks';

const RecentActivity: FC = () => {
  const notify = useNotify();
  const { t } = useTranslation();
  const { data, isLoading } = useGetActionsQuery(
    { limit: 5 },
    {
      onError: notify.queryError,
    }
  );

  const results = data?.getActions?.results ?? [];

  if (isLoading || !results.length) {
    return null;
  }

  return (
    <Grid item xs>
      <ActivityWidget results={results} title={t('components:recentActivity')} />
    </Grid>
  );
};

export default RecentActivity;
